module.exports = __webpack_public_path__ + "img/fomo_rareruggapes.b99cdca.png";